export class Viewing {

        constructor(
          public Brand: string,
          public PropertyReference: string,
          public PropertyAddress: string,
          public Email: string,
          public FirstName: string,
          public LastName: string,
          public PhoneNumber: string,
          public Title: string,
          public PropertyToSell: boolean,
          public ViewingDate: string,
          public ViewingTime: string,
          public BranchEmail: string,
          public FromEmail: string,
          public OfficeId: string
          ) {  }
    }



// WEBPACK FOOTER //
// D:/FLINK/FlinkViewingPageDec2020/NewLandingPage/src/app/viewingForm/viewing.ts